import cx from 'classnames';
import styles from '../../Leaderboard.module.scss';
import { getNumberFormat } from '@cp/src/utils/commonUtils';
import { Typography } from '@navi/web-ui/lib/primitives';
import { INCENTIVE_BUCKET_GROUP } from '../../leaderboardConstant';
import { IncentiveData } from '@cp/src/reducers/leaderboardSlice';

type IOldSlabTooltipContent = {
  selectedRadioOption?: INCENTIVE_BUCKET_GROUP;
  selectedIncentiveData?: IncentiveData;
  totalCashCollectedForSelectedRadioOption?: number;
  totalIncentiveEarnedForSelectedRadioOption?: number;
};

const OldSlabTooltipContent = (props: IOldSlabTooltipContent) => {
  const {
    selectedRadioOption,
    selectedIncentiveData,
    totalCashCollectedForSelectedRadioOption,
    totalIncentiveEarnedForSelectedRadioOption
  } = props;

  const isTotalOptionSelected = selectedRadioOption === INCENTIVE_BUCKET_GROUP.TOTAL;

  const toShowBuffer =
    selectedRadioOption === INCENTIVE_BUCKET_GROUP.DPD_1_TO_30
      ? (selectedIncentiveData?.buffer1To30DaysCashCollected ?? 0) > 0
      : (selectedIncentiveData?.buffer30PlusDaysCashCollected ?? 0) > 0;

  return (
    <>
      {isTotalOptionSelected && (
        <div className="flex justify-between">
          <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
            Total Cash Collected (a)
          </Typography>
          <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
            {getNumberFormat(selectedIncentiveData?.totalCashCollected, 2) || `₹0`}
          </Typography>
        </div>
      )}

      <div className={cx('flex justify-between', 'mb-[6px]')}>
        <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
          {!isTotalOptionSelected
            ? `Total cash collected on your ${selectedRadioOption} cases`
            : `Threshold for incentives (b)`}
        </Typography>
        <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
          {getNumberFormat(totalCashCollectedForSelectedRadioOption, 2) || `₹0`}
        </Typography>
      </div>

      {isTotalOptionSelected && (
        <div className={cx('py-[6px]', 'flex', 'justify-between', styles.tooltipBorder)}>
          <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
            Amount eligible for incentives (a-b)
          </Typography>
          <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
            {getNumberFormat(selectedIncentiveData?.amountEligibleForIncentive, 2) || `₹0`}
          </Typography>
        </div>
      )}

      <div className="flex justify-between">
        <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
          {!isTotalOptionSelected
            ? `Incentive earned on your ${selectedRadioOption} cases`
            : `Incentives earned (${selectedIncentiveData?.incentivePercentage}% of eligible amount)`}
        </Typography>
        <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
          {getNumberFormat(totalIncentiveEarnedForSelectedRadioOption, 2)}
        </Typography>
      </div>
      {selectedIncentiveData?.bufferCashCollected ?? 0 > 0 ? (
        <>
          {!isTotalOptionSelected && toShowBuffer ? (
            <div className={cx('flex justify-between', 'mb-[6px] mt-[6px]')}>
              <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
                Buffer cash collected on {selectedRadioOption} cases
              </Typography>
              <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
                {selectedRadioOption === INCENTIVE_BUCKET_GROUP.DPD_1_TO_30
                  ? getNumberFormat(selectedIncentiveData?.buffer1To30DaysCashCollected, 2)
                  : getNumberFormat(selectedIncentiveData?.buffer30PlusDaysCashCollected, 2)}
              </Typography>
            </div>
          ) : null}

          {!isTotalOptionSelected && toShowBuffer ? (
            <div className={cx('flex justify-between', 'mb-[6px]')}>
              <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
                Incentive earned on {selectedRadioOption} buffer cases
              </Typography>
              <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
                {selectedRadioOption === INCENTIVE_BUCKET_GROUP.DPD_1_TO_30
                  ? getNumberFormat(selectedIncentiveData?.buffer1To30DaysIncentiveEarned, 2)
                  : getNumberFormat(selectedIncentiveData?.buffer30PlusDaysIncentiveEarned, 2)}
              </Typography>
            </div>
          ) : null}
          {!isTotalOptionSelected && toShowBuffer ? (
            <div className={cx('flex justify-between', 'mb-[6px]')}>
              <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
                Total incentive earned on all cases
              </Typography>
              <Typography color="var(--text-primary)" className="text-[13px]" variant="p4">
                {selectedRadioOption === INCENTIVE_BUCKET_GROUP.DPD_1_TO_30
                  ? getNumberFormat(selectedIncentiveData?.total1To30DaysIncentiveEarned, 2)
                  : getNumberFormat(selectedIncentiveData?.total30PlusDaysIncentiveEarned, 2)}
              </Typography>
            </div>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default OldSlabTooltipContent;
